import { render, staticRenderFns } from "./shipment-payment-card-form.vue?vue&type=template&id=91985a20"
import script from "./shipment-payment-card-form.vue?vue&type=script&lang=js"
export * from "./shipment-payment-card-form.vue?vue&type=script&lang=js"
import style0 from "./shipment-payment-card-form.vue?vue&type=style&index=0&id=91985a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports